export default __webpack_public_path__ + "static/media/pricing_list.fc00d9ed.svg";